"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["local"] = "local";
    Environment["development"] = "development";
    Environment["production"] = "production";
})(Environment || (exports.Environment = Environment = {}));
